import { isBetaFeatureEnabled } from "./feature-flag";

/**
 * 인스펙터가 베타 요소를 집어낼 때 쓰는 클래스. `global.css` 의
 * `body.beta-feature-inspector .beta-feature-inset-target` 과 짝이다.
 *
 * 요소 안쪽에 테두리를 그리는 inset 형태라, 그룹 컨트롤의 개별 항목처럼
 * 바깥 outline 이 옆 항목과 겹치는 자리에 쓴다.
 */
export const BETA_FEATURE_INSET_MARK_CLASS = "beta-feature-inset-target";

interface BetaFeatureOption {
  isBetaFeature?: boolean;
  className?: string;
}

/**
 * 옵션 **배열**로 항목을 받는 컨트롤(`ViewSwitchGroup` 등)의 베타 처리.
 * 베타가 꺼져 있으면 베타 항목을 빼고, 켜져 있으면 인스펙터 표식을 붙인다.
 *
 * children 으로 항목을 받는 컨트롤은 `BetaFeatureOnly` 로 감싸면 된다
 * (`BetaFeatureSegmentControl`). 두 경로가 같은 규칙을 쓰도록 필터 조건과
 * 표식은 이 모듈 한 곳에서만 정한다.
 */
export const resolveBetaFeatureOptions = <T extends BetaFeatureOption>(
  options: T[],
): T[] => {
  const betaFeatureEnabled = isBetaFeatureEnabled();

  return options.flatMap((option) => {
    if (!option.isBetaFeature) return [option];
    if (!betaFeatureEnabled) return [];
    return [
      {
        ...option,
        className: [option.className, BETA_FEATURE_INSET_MARK_CLASS]
          .filter(Boolean)
          .join(" "),
      },
    ];
  });
};
